<template>
  <div class="mx-auto mt-[20px] px-[10px] pb-[20px] max-w-[1350px]">
    <div class="text-2xl">
      Щоб отримати доступ до цього контенту, необхідна
      <a
        href="https://base.monobank.ua/olsior#subscriptions"
        target="_blank"
        class="link"
        >підписка на Монобанк</a>.
    </div>
    <a
      class="flex gap-3 mt-[10px] w-fit btn btn-neutral"
      href="https://base.monobank.ua/olsior#subscriptions"
      target="_blank"
    >
      <img
        class="bg-neutral rounded-full w-[36px] h-[36px]"
        src="/mono.svg"
        alt=""
      />
      <span> Монобанк </span>
    </a>

    <div class="flex flex-col gap-[10px] mt-[20px] lg:max-w-[600px]">
      <a href="/auth-1.jpg">
        <img src="/auth-1.jpg" class="w-full" alt="1">
      </a>
      <a href="/auth-2.jpg">
        <img src="/auth-2.jpg" class="w-full" alt="2">
      </a>
    </div>

    <div class="mt-[20px] text-2xl">Щоб перевірити підписку авторизуйтесь:</div>
    <button
      class="flex gap-3 mt-[10px] btn btn-neutral"
      @click="loginWithDiscord"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M19.27 5.33C17.94 4.71 16.5 4.26 15 4a.1.1 0 0 0-.07.03c-.18.33-.39.76-.53 1.09a16.1 16.1 0 0 0-4.8 0c-.14-.34-.35-.76-.54-1.09c-.01-.02-.04-.03-.07-.03c-1.5.26-2.93.71-4.27 1.33c-.01 0-.02.01-.03.02c-2.72 4.07-3.47 8.03-3.1 11.95c0 .02.01.04.03.05c1.8 1.32 3.53 2.12 5.24 2.65c.03.01.06 0 .07-.02c.4-.55.76-1.13 1.07-1.74c.02-.04 0-.08-.04-.09c-.57-.22-1.11-.48-1.64-.78c-.04-.02-.04-.08-.01-.11c.11-.08.22-.17.33-.25c.02-.02.05-.02.07-.01c3.44 1.57 7.15 1.57 10.55 0c.02-.01.05-.01.07.01c.11.09.22.17.33.26c.04.03.04.09-.01.11c-.52.31-1.07.56-1.64.78c-.04.01-.05.06-.04.09c.32.61.68 1.19 1.07 1.74c.03.01.06.02.09.01c1.72-.53 3.45-1.33 5.25-2.65c.02-.01.03-.03.03-.05c.44-4.53-.73-8.46-3.1-11.95c-.01-.01-.02-.02-.04-.02M8.52 14.91c-1.03 0-1.89-.95-1.89-2.12s.84-2.12 1.89-2.12c1.06 0 1.9.96 1.89 2.12c0 1.17-.84 2.12-1.89 2.12m6.97 0c-1.03 0-1.89-.95-1.89-2.12s.84-2.12 1.89-2.12c1.06 0 1.9.96 1.89 2.12c0 1.17-.83 2.12-1.89 2.12"
        />
      </svg>
      <span> {{ $t('loginDiscord') }} </span>
    </button>
  </div>
</template>

<script setup>
const { getProviderAuthenticationUrl } = useStrapiAuth()

const loginWithDiscord = () => {
  // Провайдера читає /auth/callback — з /live можна зайти ще й через Twitch
  useCookie('auth_provider', { path: '/' }).value = 'discord'
  window.location.href = getProviderAuthenticationUrl('discord')
}
</script>
